// File: SignupPage.js
import React from "react";
import "./SignupPage.css";
import {
  FaUser,
  FaEnvelope,
  FaPhoneAlt,
  FaLock,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
} from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

const SignupPage = () => {
  return (
    <div className="signup-page">
      <div className="overlay">
        <div className="signup-content">
          <div className="left-section">
            <h1>Welcome to Talent Trek Technologies</h1>
            <p>
              Join us today and shape your future with endless learning and career opportunities.
              Register now to access our top training programs and personalized support.
            </p>
          </div>

          <div className="right-section">
            <h2>
              <FaUser className="form-title-icon" /> Register:
            </h2>
            <form className="signup-form">
              <div className="input-box">
                <FaUser className="icon" />
                <input type="text" placeholder="Your name" />
              </div>

              <div className="input-box">
                <FaEnvelope className="icon" />
                <input type="email" placeholder="Your email" />
              </div>

              <div className="input-box">
                <FaPhoneAlt className="icon" />
                <input type="tel" placeholder="Contact number" />
              </div>

              <div className="input-box">
                <FaLock className="icon" />
                <input type="password" placeholder="Your password" />
              </div>

              <div className="input-box">
                <FaLock className="icon" />
                <input type="password" placeholder="Confirm password" />
              </div>

              <button className="signup-btn0">SIGN UP</button>

              <div className="social-icons">
                <FaFacebookF className="icon fb" title="Facebook" />
                <FcGoogle className="icon" title="Google" />
                <FaTwitter className="icon twitter" title="Twitter" />
                <FaLinkedinIn className="icon linkedin" title="LinkedIn" />
              </div>

              <div className="login-text">
                Already have an account? <a href="#">Login</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage;